import { Avatar } from "@mui/material";
import avttar from "../../../images/img1.jpeg";
import avttar1 from "../../../images/img2.jpg";
import React from "react";
import "./Container.css";
// import PushPinIcon from "@mui/icons-material/PushPin";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import { Facebook, Instagram, Twitter } from "@mui/icons-material";

function Container() {
  return (
    <div className="main-body">
      <div className="avatar">
        <Avatar alt="" src={avttar1} sx={{ width: 240, height: 240 }} />
      </div>

      <div className="details-con">
        <h2>Madhubabu Akkishetty</h2> 
        <p className="profession">
          <span>💻</span>
          Software Developer
        </p>
        <p className="location">
          <span>📍</span>
          Pune, India
        </p>
        <div className="slills">
          <span>html</span>
          <span>css</span>
          <span>javascript</span>
          <span>reactjs</span>
          <span>materialUI</span>
          {/* <span>Firebase</span> */}
        </div>
        <div className="social-handle">
          <a target="_blank" href="https://www.linkedin.com/in/madhubabu-akkishetty-a279a5175/">
            <LinkedInIcon sx={{ width: 30, height: 30 }} />
          </a>
          <a target="_blank" href="https://github.com/madhubabuakkishetty">
            <GitHubIcon sx={{ width: 30, height: 30 }} />
          </a>
          <a target="_blank" href="https://twitter.com/MAkkishetty">
            <Twitter sx={{ width: 30, height: 30 }} />
          </a>
          <a target="_blank" href="https://">
            <Facebook sx={{ width: 30, height: 30 }} />
          </a>
          <a target="_blank" href="https://">
            <Instagram sx={{ width: 30, height: 30 }} />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Container;
